import { render, staticRenderFns } from "./CustomerOrderReplicaDetail.vue?vue&type=template&id=2b1d9438&scoped=true"
import script from "./CustomerOrderReplicaDetail.vue?vue&type=script&lang=js"
export * from "./CustomerOrderReplicaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d9438",
  null
  
)

export default component.exports